<awair-floor-plan-list-item *ngFor="let deviceWithPolledAirDatum of devicesWithPolledAirData"
                            [width]="'262px'"
                            [height]="'48px'"
                            [mainText]="deviceWithPolledAirDatum?.device?.deviceName"
                            [subText]="deviceWithPolledAirDatum?.device?.floorName"
                            (itemSelect)="onItemSelect(deviceWithPolledAirDatum.device)">
  <!-- If polledAirDatum is undefined or isOffline, show gray color-->
  <awair-index-dot left
                   class="__dot"
                   [color]="deviceWithPolledAirDatum?.polledAirDatum != null && deviceWithPolledAirDatum?.polledAirDatum?.isOnline ?
                    (deviceWithPolledAirDatum?.polledAirDatum?.score | scoreToColor) : '#CDD3D8'"
                   [width]="'10px'"
                   [height]="'10px'">
  </awair-index-dot>
</awair-floor-plan-list-item>
